import { useState, useEffect } from 'react';
import axios from "axios";
import { baseurladdress } from "../baseurl"
import Sidennav from '../dashboard/sidenavbar';
import Topnavbar from '../dashboard/topnavbar';
import * as Icon from 'react-bootstrap-icons';
import Select from "react-select";
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import { useRef } from "react";

function RegionBranch() {

    const accesstoken = localStorage.getItem("token");
    const accessuserid = localStorage.getItem("staffid");

    const [activeTab, setActiveTab] = useState("region");
    const [regionList, setRegionList] = useState([]);
    const [showRegionModal, setShowRegionModal] = useState(false);

    const [regionName, setRegionName] = useState("");
    const [regionCode, setRegionCode] = useState("");

    const [showEditModal, setShowEditModal] = useState(false);
    const [editRegionId, setEditRegionId] = useState("");
    const [editRegionName, setEditRegionName] = useState("");
    const [editRegionCode, setEditRegionCode] = useState("");
    const [editRegionStatus, setEditRegionStatus] = useState(false);

    //Branch related states
    const [branchList, setBranchList] = useState([]);
    const [showBranchModal, setshowBranchModal] = useState(false);
    const [selectedRegion, setSelectedRegion] = useState(null);
    const [branchName, setBranchName] = useState("");
    const [branchCode, setBranchCode] = useState("");
    const [branchPhone, setBranchPhone] = useState("");
    const [branchMobile, setBranchMobile] = useState("");
    const [branchEmail, setBranchEmail] = useState("");
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const [cinNumber, setCinNumber] = useState("");
    const [coordinates, setCoordinates] = useState("");
    const [branchAddress, setBranchAddress] = useState("");
    const [branchPincode, setBranchPincode] = useState("");
    const [branchNabl, setBranchNabl] = useState("");
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [countryOptions, setCountryOptions] = useState([]);
    const [selectedState, setSelectedState] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [stateOptions, setStateOptions] = useState([]);
    const [districtOptions, setDistrictOptions] = useState([]);
    const [showEditBranchModal, setShowEditBranchModal] = useState(false);
    const regionOptions = regionList.map((item) => ({
        value: item.region_id,
        label: item.region_name
    }));

    //Edit branch states
    const [editBranchId, setEditBranchId] = useState("");
    const [editBranchName, setEditBranchName] = useState("");
    const [editBranchCode, setEditBranchCode] = useState("");
    const [editBranchPhone, setEditBranchPhone] = useState("");
    const [editBranchMobile, setEditBranchMobile] = useState("");
    const [editBranchEmail, setEditBranchEmail] = useState("");
    const [editPassword, setEditPassword] = useState("");
    const [editCinNumber, setEditCinNumber] = useState("");
    const [editCoordinates, setEditCoordinates] = useState("");
    const [editBranchAddress, setEditBranchAddress] = useState("");
    const [editBranchPincode, setEditBranchPincode] = useState("");
    const [editBranchNabl, setEditBranchNabl] = useState(false);
    const [editSelectedRegion, setEditSelectedRegion] = useState(null);
    const [editSelectedCountry, setEditSelectedCountry] = useState(null);
    const [editSelectedState, setEditSelectedState] = useState(null);
    const [editSelectedDistrict, setEditSelectedDistrict] = useState(null);
    const [editBranchPasswordVisible, setEditBranchPasswordVisible] = useState(false);
    const [editBranchStatus, setEditBranchStatus] = useState(false);

    //validation 
    const [phoneError, setPhoneError] = useState("");
    const [mobileError, setMobileError] = useState("");
    const [emailError, setEmailError] = useState("");
    const [editPhoneError, setEditPhoneError] = useState("");
    const [editMobileError, setEditMobileError] = useState("");
    const [editEmailError, setEditEmailError] = useState("");

    //DataTable Initialization and Cleanup code for Region List
    useEffect(() => {

        if (regionList.length === 0) return;

        let table;

        if ($.fn.DataTable.isDataTable("#regionTable")) {
            $("#regionTable").DataTable().destroy();
        }

        table = $("#regionTable").DataTable({ //Search
            pageLength: 10,
            responsive: true,
            ordering: true,
            destroy: true
        });

        return () => {
            if ($.fn.DataTable.isDataTable("#regionTable")) {
                $("#regionTable").DataTable().destroy();
            }
        };

    }, [regionList]);

    //DataTable Initialization and Cleanup for Branch List
    useEffect(() => {

        if (activeTab === "branch" && branchList.length > 0) {

            if ($.fn.DataTable.isDataTable("#branchTable")) {
                $("#branchTable").DataTable().destroy();
            }

            $("#branchTable").DataTable({
                pageLength: 10,
                responsive: true,
                ordering: true,
                destroy: true
            });
        }

        return () => {
            if ($.fn.DataTable.isDataTable("#branchTable")) {
                $("#branchTable").DataTable().destroy();
            }
        };

    }, [branchList, activeTab]);
    // Fetch Region List
    const getRegions = () => {
        axios
            .get(baseurladdress + "getregion", {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {
                //console.log("Latest Regions:", res.data.response);
                setRegionList(res.data.response);
            })
            .catch((error) => {
                console.error(error);
            });
    };
  
    useEffect(() => {
        getRegions();
    }, []);

    // Add regions
    const saveRegion = () => {
        if (regionName.trim() === "") {
            toast.warning("Enter Region Name");
            return;
        }

        if (regionCode.trim() === "") {
            toast.warning("Enter Region Code");
            return;
        }

        axios.post(
            baseurladdress + "addregions",
            {
                region_name: regionName,
                region_code: regionCode,
                region_crtby: accessuserid
            },
            {
                headers: {
                    Authorization: `Bearer ${accesstoken}`
                }
            }
        )
            .then((res) => {

                toast.success("Region Added Successfully");
                  setRegionName("");
                setRegionCode("");

                setShowRegionModal(false);

                if ($.fn.DataTable.isDataTable("#regionTable")) {
                    $("#regionTable").DataTable().destroy();
                }

                getRegions();


            })
            .catch((error) => {

                console.error(error);

                toast.error("Failed to save region");

            });
    };

    // Edit region function can be implemented here with pre-filled values and an update API call
    const handleEdit = (item) => {
        setEditRegionId(item.region_id);
        setEditRegionName(item.region_name);
        setEditRegionCode(item.region_code);
        setEditRegionStatus(item.region_status === 1);
        setShowEditModal(true);
    };

    // Update region function can be implemented here with an API call to update the region details
    const updateRegion = () => {

        if (editRegionName.trim() === "") {
            toast.warning("Enter Region Name");
            return;
        }

        if (editRegionCode.trim() === "") {
            toast.warning("Enter Region Code");
            return;
        }

        axios.post(
            baseurladdress + "updateregion",
            {
                region_id: editRegionId,
                region_name: editRegionName,
                region_code: editRegionCode,
                region_status: editRegionStatus ? 1 : 0,
                region_updby: accessuserid
            },
            {
                headers: {
                    Authorization: `Bearer ${accesstoken}`
                }
            }
        )
            .then((res) => {

                toast.success("Region Updated Successfully");

                setShowEditModal(false);

                getRegions(); // Refresh Region List

            })
            .catch((error) => {

                console.error(error);

                toast.error("Failed to update region");

            });
    };

    // List Branches function can be implemented here to fetch and display branches in the Branch tab
    const getbrnch = () => {
        axios
            .get(baseurladdress + "getbrnch", {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {
                //console.log("Latest Regions:", res.data.response);
                setBranchList(res.data.response);
            })
            .catch((error) => {
                console.error(error);
            });
    };

    useEffect(() => {
        getbrnch();
    }, []);

    // List countries
    const getCountries = () => {
        axios
            .get(baseurladdress + "getcountry", {
                headers: {
                    Authorization: `Bearer ${accesstoken}`,
                },
            })
            .then((res) => {
                console.log("Countries:", res.data.response);
                const options = res.data.response.map((item) => ({
                    value: item.cntry_id,
                    label: item.cntry_name
                }));
                console.log("countryOptions =", options)
                setCountryOptions(options);

            })
            .catch((error) => {
                console.error(error);
                toast.error("Failed to load countries");
            });
    };
    useEffect(() => {
        getCountries();
    }, []);

    //getstates
    const getStates = async (countryId) => {
        try {
            const res = await axios.get(
                baseurladdress + "getstates/" + countryId,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            const options = res.data.response.map((item) => ({
                value: item.state_id,
                label: item.state_name,
            }));

            setStateOptions(options);

            return options;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    // get Districts
    const getDistricts = async (stateId) => {
        try {
            const res = await axios.get(
                baseurladdress + "getdistrict/" + stateId,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            const options = res.data.response.map((item) => ({
                value: item.district_id,
                label: item.district_name,
            }));

            setDistrictOptions(options);

            return options;
        } catch (error) {
            console.error(error);
            return [];
        }
    };

    //Add branch function with validation
    const saveBranch = () => {

        if (!selectedRegion) {
            toast.warning("Select Region");
            return;
        }

        if (branchName.trim() === "") {
            toast.warning("Enter Branch Name");
            return;
        }

        if (branchCode.trim() === "") {
            toast.warning("Enter Branch Code");
            return;
        }

        // if (branchPhone.trim() !== "") {
        //     const phoneRegex = /^[0-9,\-\s]+$/;

        //     if (!phoneRegex.test(branchPhone)) {
        //         toast.warning("Enter valid landline number(s)");
        //         return;
        //     }
        // }

        // const mobiles = branchMobile.split(",");

        // for (let mobile of mobiles) {
        //     mobile = mobile.trim();

        //     if (!/^[6-9]\d{9}$/.test(mobile)) {
        //         toast.warning("Enter valid mobile number(s)");
        //         return;
        //     }
        // }

        // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        // if (!emailRegex.test(branchEmail)) {
        //     toast.warning("Enter a valid email address");
        //     return;
        // }

        axios.post(
            baseurladdress + "addbranches",
            {
                branch_name: branchName,
                branch_code: branchCode,
                branch_region: selectedRegion.value,

                branch_phones: branchPhone,
                branch_mobile: branchMobile,

                branch_email: branchEmail,
                branch_password: password,

                branch_cinnumber: cinNumber,
                branch_coordinate: coordinates,

                branch_nabl: branchNabl ? 1 : 0,

                branch_place: branchAddress,
                branch_resultaddress: branchAddress,

                branch_country: selectedCountry?.value || 0,
                branch_state: selectedState?.value || 0,
                branch_district: selectedDistrict?.value || 0,

                branch_pin: branchPincode,

                userid: accessuserid
            },
            {
                headers: {
                    Authorization: `Bearer ${accesstoken}`
                }
            }
        )
            .then((res) => {

                if (res.data.status === "success") {

                    toast.success("Branch Added Successfully");

                    // Clear Form
                    setBranchName("");
                    setBranchCode("");
                    setBranchPhone("");
                    setBranchMobile("");
                    setBranchEmail("");
                    setPassword("");
                    setCinNumber("");
                    setCoordinates("");
                    setBranchNabl(false);
                    setBranchAddress("");
                    setBranchPincode("");

                    setSelectedRegion(null);
                    setSelectedCountry(null);
                    setSelectedState(null);
                    setSelectedDistrict(null);

                    setshowBranchModal(false);
                    if ($.fn.DataTable.isDataTable("#branchTable")) {
                        $("#branchTable").DataTable().destroy();
                    }

                                   getbrnch(); // Refresh Branch List
                }
                else {
                    toast.error("Failed to Save Branch");
                }

            })
            .catch((error) => {
                console.error(error);
                toast.error("Failed to Save Branch");
            });
    };

    // Edit branch
    const editBranch = async (branchId) => {
        try {
            const response = await axios.get(
                `${baseurladdress}getbranchbyid/${branchId}`,
                {
                    headers: {
                        Authorization: `Bearer ${accesstoken}`,
                    },
                }
            );

            const branch = response.data.response;

            setEditBranchId(branch.branch_id);
            setEditBranchName(branch.branch_name);
            setEditBranchCode(branch.branch_code);
            setEditBranchPhone(branch.branch_phones);
            setEditBranchMobile(branch.branch_mobile);
            setEditBranchEmail(branch.branch_email);
            setEditPassword(branch.branch_password);
            setEditCinNumber(branch.branch_cinnumber);
            setEditCoordinates(branch.branch_coordinate);
            setEditBranchAddress(branch.branch_place);
            setEditBranchPincode(branch.branch_pin);
            setEditBranchNabl(branch.branch_nabl === 1);
            //setEditBranchNabl(Number(branch.branch_nabl) === 1);
            setEditBranchStatus(Number(branch.branch_status) === 1);
            // REGION
            const region = regionOptions.find(
                (item) =>
                    Number(item.value) === Number(branch.branch_region)
            );

            setEditSelectedRegion(region);

            // COUNTRY
            const country = countryOptions.find(
                (item) =>
                    Number(item.value) === Number(branch.branch_country)
            );

            setEditSelectedCountry(country);

            // LOAD STATES
            const stateList = await getStates(branch.branch_country);

            const state = stateList.find(
                (item) =>
                    Number(item.value) === Number(branch.branch_state)
            );

            setEditSelectedState(state);

            // LOAD DISTRICTS
            const districtList = await getDistricts(branch.branch_state);

            const district = districtList.find(
                (item) =>
                    Number(item.value) === Number(branch.branch_district)
            );

            setEditSelectedDistrict(district);

            setShowEditBranchModal(true);

        } catch (error) {
            console.error(error);
        }
    };

    // Update branch
    const updateBranch = () => {

        axios.post(
            baseurladdress + "updatebranch",
            {
                branch_id: editBranchId,
                branch_name: editBranchName,
                branch_code: editBranchCode,

                branch_region: editSelectedRegion?.value,

                branch_phones: editBranchPhone,
                branch_mobile: editBranchMobile,

                branch_email: editBranchEmail,
                branch_password: editPassword,

                branch_cinnumber: editCinNumber,
                branch_coordinate: editCoordinates,

                branch_nabl: editBranchNabl ? 1 : 0,

                branch_place: editBranchAddress,

                branch_country: editSelectedCountry?.value,
                branch_state: editSelectedState?.value,
                branch_district: editSelectedDistrict?.value,

                branch_pin: editBranchPincode,
                branch_status: editBranchStatus ? 1 : 0,
                branch_updby: accessuserid
            },
            {
                headers: {
                    Authorization: `Bearer ${accesstoken}`
                }
            }
        )
            .then((res) => {
                //console.log("Update Response:", res.data);
                if (res.data.status === "updated") {

                    toast.success("Branch Updated Successfully");

                    setShowEditBranchModal(false);

                    getbrnch(); // Refresh Branch List
                }
                else {

                    toast.error("Failed to Update Branch");
                }

            })
            .catch((error) => {

                console.error(error);

                toast.error("Failed to Update Branch");

            });
    };

    return (
        <div>
            <Topnavbar />
            <Sidennav />
            <ToastContainer />
            <style>{`.card {
                border - radius: 16px;
            }

            table.dataTable {
                border - collapse: separate !important;
            border-spacing: 0;
            }
            table.dataTable thead th {
                background: #F8FAFC;
            color: #334155;
            font-weight: 700;
            border-bottom: 2px solid #E2E8F0;
            }

            table.dataTable tbody td {
                padding: 15px;
            }

            table.dataTable tbody tr:hover {
                background: #F8FAFC;
            }

            .dataTables_wrapper .dataTables_filter input {
                border: 1px solid #CBD5E1;
            border-radius: 10px;
            padding: 8px 12px;
            }

            .dataTables_wrapper .dataTables_length select {
                border: 1px solid #CBD5E1;
            border-radius: 10px;
            padding: 5px;
            }

            .dataTables_wrapper .dataTables_paginate .paginate_button.current {
                background: #4F46E5 !important;
            color: white !important;
            border: none !important;
            border-radius: 8px !important;
            }

            .dataTables_wrapper .dataTables_paginate .paginate_button:hover {
                background: #6366F1 !important;
            color: white !important;
            }`}</style>
            <div className="content-wrap">
                <div className="main">
                    <div className="container-fluid">

                        <section id="main-content">

                            <div className="card border-0 shadow-lg">

                                <div className="card-header">
                                    <h5 className="mb-0">
                                        Region And Branch Management
                                    </h5>
                                </div>

                                <div className="card-body">

                                    {/* Tabs */}
                                    <ul className="nav nav-tabs mb-3">

                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === "region" ? "active" : ""
                                                    }`}
                                                onClick={() => setActiveTab("region")}
                                            >
                                                <i className="fa fa-sitemap me-2"></i>
                                                Region
                                            </button>
                                        </li>

                                        <li className="nav-item">
                                            <button
                                                className={`nav-link ${activeTab === "branch" ? "active" : ""
                                                    }`}
                                                onClick={() => setActiveTab("branch")}
                                            >
                                                <i className="fa fa-building me-2"></i>
                                                Branch
                                            </button>
                                        </li>

                                    </ul>

                                    {/* Region Tab */}
                                  
                                    {activeTab === "region" && (
                                        <div>

                                            {/* Header */}
                                            <div className="card-header bg-white">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <h6 className="fw-bold mb-0">
                                                        Region Management
                                                    </h6>
                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={() => setShowRegionModal(true)}
                                                    >
                                                        <Icon.PlusCircle className="me-2" />
                                                        Add Region
                                                    </button>
                                                </div>
                                            </div>

                                         {/* Table Card */}
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-header bg-white border-bottom">
                                                    <h6 className="mb-0 fw-semibold">
                                                        Region List
                                                    </h6>
                                                </div>
                                                <div className="card-body">

                                                    <table
                                                       // key={regionList.length}
                                                        id="regionTable"
                                                        className="table table-hover table-bordered align-middle"
                                                        width="100%"
                                                    >
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th>#</th>
                                                                <th>Region Name</th>
                                                                <th>Region Code</th>
                                                                <th>Status</th>
                                                                <th className="text-center">Actions</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {regionList.map((item, index) => (
                                                                <tr key={item.region_id}>
                                                                    <td>{index + 1}</td>
                                                                    <td>{item.region_name}</td>
                                                                    <td>{item.region_code}</td>
                                                                    <td className="text-center">
                                                                        {item.region_status === 1 ? (
                                                                            <span
                                                                                style={{
                                                                                    background: "#dcfce7",
                                                                                    color: "#15803d",
                                                                                    padding: "5px 15px",
                                                                                    borderRadius: "50px",
                                                                                    fontWeight: "600",
                                                                                    fontSize: "13px"
                                                                                }}
                                                                            >
                                                                                 Active
                                                                            </span>
                                                                        ) : (
                                                                            <span
                                                                                style={{
                                                                                    background: "#fee2e2",
                                                                                    color: "#dc2626",
                                                                                    padding: "5px 15px",
                                                                                    borderRadius: "50px",
                                                                                    fontWeight: "600",
                                                                                    fontSize: "13px"
                                                                                }}
                                                                            >
                                                                                Inactive
                                                                            </span>
                                                                        )}
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <i
                                                                            className="fa fa-pencil text-primary"
                                                                            style={{ cursor: "pointer", fontSize: "18px" }}
                                                                            onClick={() => handleEdit(item)}
                                                                        ></i>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>

                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    {/* Branch Tab */}
                                    {activeTab === "branch" && (
                                        <div>
                                            {/* Header */}
                                            <div className="card-header bg-white">
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        justifyContent: "space-between",
                                                        alignItems: "center",
                                                        width: "100%"
                                                    }}
                                                >
                                                    <h6 className="fw-bold mb-0">
                                                        Branch Management
                                                    </h6>
                                                    <button
                                                        className="btn btn-primary"
                                                        onClick={() => setshowBranchModal(true)}
                                                    >
                                                        <Icon.PlusCircle className="me-2" />
                                                        Add Branch
                                                    </button>
                                                </div>
                                            </div>

                                            {/* Table Card */}
                                            <div className="card border-0 shadow-sm">
                                                <div className="card-header bg-white border-bottom">
                                                    <h6 className="mb-0 fw-semibold">
                                                        Branch List
                                                    </h6>
                                                </div>
                                                <div className="card-body">
                                                    <table
                                                        id="branchTable"
                                                        className="table table-hover table-bordered align-middle"
                                                        width="100%"
                                                    >
                                                        <thead className="table-light">
                                                            <tr>
                                                                
                                                                <th>Branch Name</th>
                                                                <th>Branch Code</th>
                                                                <th>Contact Number</th>
                                                                <th>Address</th>
                                                                <th>Status</th>
                                                                <th className="text-center">Action</th>
                                                            </tr>
                                                        </thead>

                                                        <tbody>
                                                            {branchList.map((item, index) => (
                                                                <tr key={item.branch_id}>
                                                                   
                                                                    <td>{item.branch_name}</td>
                                                                    <td>{item.branch_code}</td>
                                                                    <td>
                                                                        {[item.branch_phones, item.branch_mobile]
                                                                            .filter(Boolean)
                                                                            .join(", ")}
                                                                    </td>
                                                                    <td>{item.branch_place}</td>

                                                                    <td>
                                                                        {item.branch_status === 1 ? (
                                                                            <span
                                                                                style={{
                                                                                    background: "#dcfce7",
                                                                                    color: "#15803d",
                                                                                    padding: "5px 15px",
                                                                                    borderRadius: "50px",
                                                                                    fontWeight: "600",
                                                                                    fontSize: "13px"
                                                                                }}
                                                                            >
                                                                                Active
                                                                            </span>
                                                                        ) : (
                                                                            <span
                                                                                style={{
                                                                                    background: "#fee2e2",
                                                                                    color: "#dc2626",
                                                                                    padding: "5px 15px",
                                                                                    borderRadius: "50px",
                                                                                    fontWeight: "600",
                                                                                    fontSize: "13px"
                                                                                }}
                                                                            >
                                                                                Inactive
                                                                            </span>
                                                                        )}
                                                                    </td>

                                                                    <td className="text-center">
                                                                        <Icon.PencilSquare
                                                                            size={18}
                                                                            className="text-primary me-3"
                                                                            style={{ cursor: "pointer" }}
                                                                            onClick={() => editBranch(item.branch_id)}
                                                                            title="Edit"
                                                                        />

                                                                       
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                   

                                                </div>
                                            </div>
                                        </div>
                                    )}

                                </div>

                            </div>

                        </section>
                    </div>
                </div>
            </div>

            {/*Add Region modal box*/ }
            {showRegionModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                            backgroundColor: "rgba(0,0,0,0.5)"
                        }}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Add Region
                                    </h5>

                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowRegionModal(false)}
                                    >X</button>
                                </div>

                                <div className="modal-body">

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Region Name
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Region Name"
                                            value={regionName}
                                            onChange={(e) =>
                                                setRegionName(e.target.value)
                                            }
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Region Code
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Enter Region Code"
                                            value={regionCode}
                                            onChange={(e) =>
                                                setRegionCode(e.target.value)
                                            }
                                        />
                                    </div>

                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowRegionModal(false)}
                                    >
                                        Close
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={saveRegion}
                                    >
                                        Save
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            {/*Edit Region Modal can be implemented  with pre-filled values and an update function*/}
            {showEditModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                            backgroundColor: "rgba(0,0,0,0.5)"
                        }}
                    >
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Edit Region
                                    </h5>
                                </div>

                                <div className="modal-body">

                                    <div className="mb-3">
                                          <input
                                            type="hidden"
                                            className="form-control"
                                            value={editRegionId}
                                            readOnly
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">
                                            Region Name
                                        </label>

                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editRegionName}
                                            onChange={(e) =>
                                                setEditRegionName(e.target.value)
                                            }
                                        />
                                    </div>

                                    <div className="row">

                                        <div className="col-md-6">
                                            <label className="form-label">
                                                Region Code
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editRegionCode}
                                                onChange={(e) =>
                                                    setEditRegionCode(e.target.value)
                                                }
                                            />
                                        </div>

                                        <div className="col-md-6 d-flex align-items-center">
                                            <div className="form-check mt-4">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="regionStatus"
                                                    checked={editRegionStatus}
                                                    onChange={(e) =>
                                                        setEditRegionStatus(e.target.checked)
                                                    }
                                                />

                                                <label
                                                    className="form-check-label fw-semibold ms-2"
                                                    htmlFor="regionStatus"
                                                >
                                                    {editRegionStatus ? (
                                                        <span className="text-success">
                                                            Active
                                                        </span>
                                                    ) : (
                                                        <span className="text-danger">
                                                            Inactive
                                                        </span>
                                                    )}
                                                </label>
                                            </div>
                                        </div>

                                    </div>

                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowEditModal(false)}
                                    >
                                        Close
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={updateRegion}
                                    >
                                        Update
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            {/* branch add modal box*/ }
            {showBranchModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                            backgroundColor: "rgba(0,0,0,0.5)"
                        }}
                    >
                        <div
                            className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                            style={{
                                maxWidth: "1000px"
                            }}
                        >
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Add Branch
                                    </h5>

                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setshowBranchModal(false)}
                                    >X</button>
                                </div>

                                <div className="modal-body" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto"
                                }}>
                                    <div className="row">
                                    <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                <span className="text-danger">*</span> Region
                                            </label>

                                        <Select
                                            options={regionOptions}
                                            value={selectedRegion}
                                            onChange={(selected) => setSelectedRegion(selected)}
                                            placeholder="Select Region"
                                            isSearchable
                                            className="react-select-container"
                                            classNamePrefix="react-select"
                                        />
                                    </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                <span className="text-danger">*</span> Branch Name
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Branch Name"
                                                value={branchName}
                                                onChange={(e) => setBranchName(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                <span className="text-danger">*</span> Branch Code
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Branch Code"
                                                value={branchCode}
                                                onChange={(e) => setBranchCode(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Phone Number(s) (Landline)
                                            </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e.g. 0495-123456"
                                                value={branchPhone}
                                                onChange={(e) => {
                                                    const value = e.target.value;
                                                    setBranchPhone(value);

                                                    const phoneRegex = /^[0-9,\-\s]*$/;

                                                    if (!phoneRegex.test(value)) {
                                                        setPhoneError("Only numbers, commas and hyphens are allowed");
                                                    } else {
                                                        setPhoneError("");
                                                    }
                                                }}
                                            />

                                            {phoneError && (
                                                <small className="text-danger">{phoneError}</small>
                                            )}
                                            {/* <input
                                                type="text"
                                                className="form-control"
                                                placeholder="e.g. 0495-123456, 0495-654321"
                                                value={branchPhone}
                                                onChange={(e) => setBranchPhone(e.target.value)}
                                            />*/}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Mobile Number(s)
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Enter Mobile Number"
                                                //maxLength={10}
                                                value={branchMobile}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setBranchMobile(value);

                                                    if (
                                                        value !== "" &&
                                                        !/^[6-9]\d{0,9}$/.test(value)
                                                    ) {
                                                        setMobileError(
                                                            "Mobile number must start with 6-9"
                                                        );
                                                    } else {
                                                        setMobileError("");
                                                    }
                                                }}
                                            />

                                            {mobileError && (
                                                <small className="text-danger">{mobileError}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Email Address
                                            </label>

                                            <input
                                                type="email"
                                                className="form-control"
                                                placeholder="Enter Email Address"
                                                value={branchEmail}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setBranchEmail(value);

                                                    const emailRegex =
                                                        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                                    if (
                                                        value !== "" &&
                                                        !emailRegex.test(value)
                                                    ) {
                                                        setEmailError("Enter a valid email address");
                                                    } else {
                                                        setEmailError("");
                                                    }
                                                }}
                                            />

                                            {emailError && (
                                                <small className="text-danger">{emailError}</small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Password
                                            </label>

                                            <div className="input-group">
                                                <input
                                                    type={showPassword ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="Enter Password"
                                                    value={password}
                                                    onChange={(e) => setPassword(e.target.value)}
                                                />

                                                <span
                                                    className="input-group-text"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => setShowPassword(!showPassword)}
                                                >
                                                    {showPassword ? (
                                                        <Icon.EyeSlashFill />
                                                    ) : (
                                                        <Icon.EyeFill />
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                CIN Number(s)
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="CIN Number"
                                                value={cinNumber}
                                                onChange={(e) => setCinNumber(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Coordinates
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Coordinates"
                                                value={coordinates}
                                                onChange={(e) => setCoordinates(e.target.value)}
                                            />
                                        </div>
                                        
                                    </div>
                                    <div className="row">

                                        {/* Address */}
                                        <div className="col-md-8 mb-3">
                                            <label className="form-label">
                                                Address
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows="8"
                                                 style={{ height: "100px", resize: "none" }}
                                                placeholder="Enter Address"
                                                value={branchAddress}
                                                onChange={(e) => setBranchAddress(e.target.value)}
                                            />
                                        </div>

                                        {/* Right Side */}
                                        <div className="col-md-4">

                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Pincode
                                                </label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Pincode"
                                                    maxLength={6}
                                                    value={branchPincode}
                                                    onChange={(e) => setBranchPincode(e.target.value)}
                                                />
                                            </div>

                                            <div className="mb-3 mt-4">
                                                <div className="form-check">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="nablCheck"
                                                        checked={branchNabl}
                                                        onChange={(e) => setBranchNabl(e.target.checked)}
                                                    />

                                                    <label
                                                        className="form-check-label fw-semibold"
                                                        htmlFor="nablCheck"
                                                    >
                                                        NABL
                                                    </label>
                                                </div>
                                            </div>

                                        </div>
                                     
                                    </div>
                                    <div className="row">

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Country
                                            </label>

                                            <Select
                                                options={countryOptions}
                                                value={selectedCountry}
                                                onChange={(selected) => {

                                                    setSelectedCountry(selected);

                                                    setSelectedState(null);

                                                    getStates(selected.value);

                                                }}
                                                placeholder="Select Country"
                                                isSearchable
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                State
                                            </label>

                                            <Select
                                                options={stateOptions}
                                                value={selectedState}
                                                onChange={(selected) => {

                                                    setSelectedState(selected);

                                                    setSelectedDistrict(null);

                                                    if (selected) {
                                                        getDistricts(selected.value);
                                                    }

                                                }}
                                                placeholder="Select State"
                                                isSearchable
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                District
                                            </label>

                                            <Select
                                                options={districtOptions}
                                                value={selectedDistrict}
                                                onChange={setSelectedDistrict}
                                                placeholder="Select District"
                                                isSearchable
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setshowBranchModal(false)}
                                    >
                                        Close
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={saveBranch}
                                    >
                                        Save
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}

            {/* branch edit modal box*/}
            {showEditBranchModal && (
                <>
                    <div
                        className="modal fade show"
                        style={{
                            display: "block",
                            backgroundColor: "rgba(0,0,0,0.5)"
                        }}
                    >
                        <div
                            className="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                            style={{
                                maxWidth: "1000px"
                            }}
                        >
                            <div className="modal-content">

                                <div className="modal-header">
                                    <h5 className="modal-title">
                                        Edit Branch
                                    </h5>

                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setShowEditBranchModal(false)}
                                    >X</button>
                                </div>

                                <div className="modal-body" style={{
                                    maxHeight: "70vh",
                                    overflowY: "auto"
                                }}>
                                    <div className="row">
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Region
                                            </label>

                                            <Select
                                                options={regionOptions}
                                                value={editSelectedRegion}
                                                onChange={setEditSelectedRegion}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Branch Name
                                            </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={editBranchName}
                                            onChange={(e) => setEditBranchName(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Branch Code
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editBranchCode}
                                                onChange={(e) => setEditBranchCode(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Phone Number(s) (Landline)
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editBranchPhone}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setEditBranchPhone(value);

                                                    const phoneRegex = /^[0-9,\-\s]*$/;

                                                    if (!phoneRegex.test(value)) {
                                                        setEditPhoneError(
                                                            "Only numbers, commas and hyphens are allowed"
                                                        );
                                                    } else {
                                                        setEditPhoneError("");
                                                    }
                                                }}
                                            />

                                            {editPhoneError && (
                                                <small className="text-danger">
                                                    {editPhoneError}
                                                </small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Mobile Number(s)
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                value={editBranchMobile}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setEditBranchMobile(value);

                                                    const mobiles = value.split(",");

                                                    let isValid = true;

                                                    for (let mobile of mobiles) {
                                                        mobile = mobile.trim();

                                                        if (
                                                            mobile !== "" &&
                                                            !/^[6-9]\d{9}$/.test(mobile)
                                                        ) {
                                                            isValid = false;
                                                            break;
                                                        }
                                                    }

                                                    if (!isValid) {
                                                        setEditMobileError(
                                                            "Enter valid 10-digit mobile number(s) separated by commas"
                                                        );
                                                    } else {
                                                        setEditMobileError("");
                                                    }
                                                }}
                                            />

                                            {editMobileError && (
                                                <small className="text-danger">
                                                    {editMobileError}
                                                </small>
                                            )}

                                            {editMobileError && (
                                                <small className="text-danger">
                                                    {editMobileError}
                                                </small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Email Address
                                            </label>

                                            <input
                                                type="email"
                                                className="form-control"
                                                value={editBranchEmail}
                                                onChange={(e) => {
                                                    const value = e.target.value;

                                                    setEditBranchEmail(value);

                                                    const emailRegex =
                                                        /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                                                    if (
                                                        value !== "" &&
                                                        !emailRegex.test(value)
                                                    ) {
                                                        setEditEmailError(
                                                            "Enter a valid email address"
                                                        );
                                                    } else {
                                                        setEditEmailError("");
                                                    }
                                                }}
                                            />

                                            {editEmailError && (
                                                <small className="text-danger">
                                                    {editEmailError}
                                                </small>
                                            )}
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Password
                                            </label>

                                            <div className="input-group">
                                                <input
                                                    type={editBranchPasswordVisible ? "text" : "password"}
                                                    className="form-control"
                                                    placeholder="Enter Password"
                                                    value={editPassword}
                                                    onChange={(e) => setEditPassword(e.target.value)}
                                                />

                                                <span
                                                    className="input-group-text"
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => setEditBranchPasswordVisible(!editBranchPasswordVisible)}
                                                >
                                                    {editBranchPasswordVisible ? (
                                                        <Icon.EyeSlashFill />
                                                    ) : (
                                                        <Icon.EyeFill />
                                                    )}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                CIN Number(s)
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="CIN Number"
                                                value={editCinNumber}
                                                onChange={(e) => setEditCinNumber(e.target.value)}
                                            />
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Coordinates
                                            </label>

                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Coordinates"
                                                value={editCoordinates}
                                                onChange={(e) => setEditCoordinates(e.target.value)}
                                            />
                                        </div>

                                    </div>
                                    <div className="row">

                                        {/* Address */}
                                        <div className="col-md-8 mb-3">
                                            <label className="form-label">
                                                Address
                                            </label>

                                            <textarea
                                                className="form-control"
                                                rows="8"
                                                style={{ height: "100px", resize: "none" }}
                                                placeholder="Enter Address"
                                                value={editBranchAddress}
                                                onChange={(e) => setEditBranchAddress(e.target.value)}
                                            />
                                        </div>

                                        {/* Right Side */}
                                        <div className="col-md-4">

                                            <div className="mb-3">
                                                <label className="form-label">
                                                    Pincode
                                                </label>

                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Enter Pincode"
                                                    maxLength={6}
                                                    value={editBranchPincode}
                                                    onChange={(e) => setEditBranchPincode(e.target.value)}
                                                />
                                            </div>


                                            <div className="row mt-4">

                                                <div className="col-md-6">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="nablCheck"
                                                            checked={editBranchNabl}
                                                            onChange={(e) => setEditBranchNabl(e.target.checked)}
                                                        />

                                                        <label
                                                            className="form-check-label fw-semibold"
                                                            htmlFor="nablCheck"
                                                        >
                                                            NABL
                                                        </label>
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="checkbox"
                                                            id="statusCheck"
                                                            checked={editBranchStatus}
                                                            onChange={(e) => setEditBranchStatus(e.target.checked)}
                                                        />
                                                        <label
                                                            className="form-check-label fw-semibold"
                                                            htmlFor="statusCheck"
                                                        >
                                                            {editBranchStatus ? (
                                                                <span className="text-success">Active</span>
                                                            ) : (
                                                                <span className="text-danger">Inactive</span>
                                                            )}
                                                        </label>
                                                    </div>
                                                </div>

                                            </div>


                                        </div>

                                    </div>
                                    <div className="row">

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                Country
                                            </label>

                                            <Select
                                            isSearchable
                                                options={countryOptions}
                                                value={editSelectedCountry}
                                                onChange={(selected) => {
                                                    setEditSelectedCountry(selected);
                                                    getStates(selected.value);
                                                }}
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                State
                                            </label>

                                            <Select
                                                options={stateOptions}
                                                value={editSelectedState}
                                                onChange={(selected) => {
                                                    setEditSelectedState(selected);
                                                    getDistricts(selected.value);
                                                }}
                                                isSearchable
                                            />
                                        </div>

                                        <div className="col-md-4 mb-3">
                                            <label className="form-label">
                                                District
                                            </label>

                                            <Select
                                                options={districtOptions}
                                                value={editSelectedDistrict}
                                                onChange={setEditSelectedDistrict}
                                                isSearchable
                                            />
                                        </div>

                                    </div>
                                </div>

                                <div className="modal-footer">
                                    <button
                                        className="btn btn-secondary"
                                        onClick={() => setShowEditBranchModal(false)}
                                    >
                                        Close
                                    </button>

                                    <button
                                        type="button"
                                        className="btn btn-primary"
                                        onClick={updateBranch}
                                    >
                                        Update
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div className="modal-backdrop fade show"></div>
                </>
            )}
        </div>

    )
}

export default RegionBranch;